export default __webpack_public_path__ + "static/media/P-043.d6732c57.png";